/* eslint-disable @typescript-eslint/no-explicit-any */

import { FC, useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';

import ExchangesTable from './ExchangesTable/ExchangesTable';
import { getExchanges } from './getExchanges';
import { Exchange, TableFilters } from './types';

type ExchangesProps = {
  tableHeight?: string;
};

const initialFilters: TableFilters = {
  fechaDesde: null,
  fechaHasta: null,
  armadores: [],
  codPlaya: '',
  incluirCargas: false,
};

const Exchanges: FC<ExchangesProps> = () => {
  const [filters, setFilters] = useState(initialFilters);
  const [parsedData, setParsedData] = useState<Exchange[]>([]);
  const {
    data: exchanges,
    mutate,
    isPending,
  } = useMutation({
    mutationKey: ['Exchanges'],
    mutationFn: () => getExchanges(filters),
  });
  useEffect(() => {
    if (exchanges) {
      const newData = exchanges.map((item: any) => {
        const { fechaAbierto, fechaLlegada, fechaSalida, ...rest } = item;

        const formattedCierreStacking = new Date(item?.fechaAbierto);
        const formatFechaLlegada = new Date(item?.fechaLlegada);
        const formatFechaSalida = new Date(item?.fechaSalida);

        return {
          ...rest,
          fechaAbierto: formattedCierreStacking,
          fechaLlegada: formatFechaLlegada,
          fechaSalida: formatFechaSalida,
          destino: item.destino.split(' ').filter(Boolean).join('/'),
        };
      });
      setParsedData(newData);
    }
  }, [exchanges]);

  return (
    <ExchangesTable
      data={parsedData || []}
      filters={filters}
      setFilters={setFilters}
      onSearch={mutate}
      isLoading={isPending}
    />
  );
};

export default Exchanges;
